module.exports = __webpack_public_path__ + "img/header-banner--about.c61796b8.png";